import type { ColumnDef } from "@tanstack/react-table";
import { StatusBadge } from "@/accounts-payable/common";
import type { ApInvoice } from "@/accounts-payable/types";
import { invoiceStatusMeta } from "@/accounts-payable/utils";

export const statusCol: ColumnDef<ApInvoice> = {
  accessorKey: "status",
  header: "Status",
  meta: { size: "150px" },
  cell: ({ row }) => <StatusBadge meta={invoiceStatusMeta(row.original)} />,
};
